'use strict';

class CTextAreaController{
  constructor(){
  }
  $onInit(){

  }
}
export default CTextAreaController;



// WEBPACK FOOTER //
// ./src/app/common/core/util/c-components-bootstrap/c-textarea/c-textarea.controller.js